import {
  faClock,
  faCoins,
  faEnvelope,
  faMapMarker,
  faPhone,
  faUser,
} from "@fortawesome/fontawesome-free-solid";
import {
  faCalendarWeek,
  faCarSide,
  faPlaneUp,
  faUserGroup,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import BookingDetailsItem from "../components/b2c/BookingDetailsItem";
import SearchResultHeading from "../components/b2c/SearchResultHeading";
import Header from "../components/landingPage/Header";
import { DirectionsService } from "@react-google-maps/api";
import { ArrowCircleLeftIcon } from "@heroicons/react/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const BookingSummary = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { booking } = useSelector((state) => state.booking);
  const { passenger } = useSelector((state) => state.passenger);
  const { vehicle } = useSelector((state) => state.vehicle);
  let order_Data;

  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  const __DEV__ = document.domain === "localhost";

  async function displayRazorpay() {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const data = await fetch(
      `${process.env.REACT_APP_BASE_URL}/razorpay?amount=${Math.round(
        booking?.priceDetails?.amount
      )}&currency=${booking?.priceDetails?.currency}`,
      {
        method: "POST",
      }
    ).then((t) => t.json());

    order_Data = data;

    const options = {
      key: __DEV__
        ? "rzp_test_puo1xjdgc63ciU"
        : process.env.REACT_APP_RAZORPAY_KEY_ID,
      currency: data.currency,
      amount: data.amount.toString(),
      order_id: data.id,
      name: "Drivado",
      description: "A global chauffeur service",
      // image: 'http://localhost:1337/logo.svg',
      handler: function (response) {
        // alert(response.razorpay_payment_id);
        // alert(response.razorpay_order_id);
        // alert(response.razorpay_signature);
        const body = {
          bookingId: booking?.bookingId,
          paymentStatus: "PAID",
          bookingStatus: "CONFIRMED",
        };

        if (
          response.razorpay_signature &&
          response.razorpay_order_id &&
          response.razorpay_payment_id
        ) {
          dispatch({
            type: "BOOKING_PAYMENT",
            payload: { body, navigate },
          });
        }
      },
      prefill: {
        name: passenger?.firstname + passenger.lastname,
        email: passenger.email,
        phone_number: passenger.phone,
      },
    };
    const paymentObject = new window.Razorpay(options);

    paymentObject.open();
  }

  // * razorpay end

  async function calculateRoute() {
    // eslint-disable-next-line no-undef
    // const directionsService = new google.maps.DirectionsService();
    // const directionsService = DirectionsService();

    const results = await DirectionsService.route({
      origin: booking?.source?.placename,
      destination: booking?.destination?.placename,
      // eslint-disable-next-line no-undef
      // travelMode: google.maps.TravelMode.DRIVING,
      travelMode: "DRIVING",
    });

    const result = DirectionsService.setDirectionsResponse(results);
    // setDistance(results.routes[0].legs[0].distance.text);
    // setDuration(results.routes[0].legs[0].duration.text);
  }

  const payHandler = () => {
    displayRazorpay();
  };

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
      // window.location.pathname = "/newbooking";
    };
  }, []);

  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = "";
    localStorage.setItem("relodePage", "true");
  };

  useEffect(() => {
    if (localStorage.getItem("relodePage")) {
      localStorage.removeItem("relodePage");
      navigate("/flatrates");
    }
  }, [navigate]);

  return (
    <div>
      <Header />
      <div className="flex sm:mx-20 mt-20 space-x-2 sm:space-x-5">
        <div>
          <Link to="/">
            <ArrowCircleLeftIcon className="w-8 text-gray-600 mt-3" />
          </Link>
        </div>
        <div className="mb-10">
          <SearchResultHeading
            searchCompleted={true}
            chVehicleCompleted={true}
            passengerCompleted={true}
          />
        </div>
      </div>
      <div className="lg:flex mx-5 lg:mx-16 xl:mx-36 my-16 mr-2 sm:mr-5">
        {/* booking Summary */}
        <div className="w-full lg:w-2/3 lg:border-r-[1px] lg:pr-6 lg:mr-2 xl:mr-6">
          <div className="text-lg text-gray-500 font-semibold mb-2 border-b border-gray-500">
            Booking Details
          </div>
          <div className="rounded-sm px-3 py-2 space-y-2">
            <BookingDetailsItem
              bookingSummery={true}
              iconname={faMapMarker}
              itemText={booking?.source?.placename}
              label="Pick up"
            />
            <BookingDetailsItem
              bookingSummery={true}
              iconname={faMapMarker}
              itemText={booking?.destination?.placename}
              label="Drop off"
            />
            <BookingDetailsItem
              bookingSummery={true}
              iconname={faCalendarWeek}
              itemText={moment(booking?.travelDate).format("DD MMM YYYY")}
              label="Date"
            />
            <BookingDetailsItem
              bookingSummery={true}
              iconname={faClock}
              itemText={booking?.travelTime}
              label="Time"
            />
            <BookingDetailsItem
              bookingSummery={true}
              iconname={faCarSide}
              itemText={
                booking?.bookingType?.charAt(0)?.toUpperCase() +
                booking?.bookingType?.slice(1).toLowerCase()
              }
              label="Boking Type"
            />
            <BookingDetailsItem
              bookingSummery={true}
              iconname={faUserGroup}
              itemText={booking?.passenger}
              label="Passengers"
            />
            <BookingDetailsItem
              bookingSummery={true}
              iconname={faCoins}
              itemText={
                Math.round(booking?.priceDetails.amount) +
                " " +
                booking?.priceDetails.currency
              }
              label="Currency"
            />
          </div>
          <div className="mt-5 space-y-2">
            <div className="text-lg text-gray-500 mb-2 font-semibold border-b border-gray-500">
              Passenger Details
            </div>

            <div className="flex items-center space-x-2 pt-2">
              <FontAwesomeIcon icon={faUser} className="w-10 text-slate-600" />
              <span className="text-[15px] w-40 text-black">Full Name:</span>
              <div className="text-[15px] text-gray-600 font-normal">
                {passenger?.firstname + " " + passenger?.lastname}
              </div>
            </div>
            <PassengerDetailItem
              iconName={faPhone}
              label="Contact Number"
              text={passenger.dial_code + " " + passenger.phone}
            />
            <PassengerDetailItem
              iconName={faEnvelope}
              label="Email"
              text={passenger.email}
            />
            <PassengerDetailItem
              iconName={faPlaneUp}
              label="Flight number"
              text={passenger.flightOrTrain}
            />
          </div>
        </div>
        {/* map with distance */}

        <div className="w-full lg:w-1/3">
          <img
            src={vehicle.image}
            alt={vehicle.vehicleType}
            className="w-1/2 md:w-1/3 lg:w-[75%] h-auto mx-auto mt-10"
          />
          <div className="mt-1 ml-5">
            <div className="flex lg:flex-row xl:flex space-x-2 items-center text-lg">
              <div className="font-semibold uppercase text-base lg:text-sm xl:text-base">
                Vehicle Type:
              </div>
              <div className="font-semibold text-secondary lg:text-sm xl:text-xl">
                {vehicle.vehicleType}
              </div>
            </div>
            <div>
              <div className="flex space-x-2 items-center text-gray-500 text-sm">
                {vehicle.description}
              </div>
            </div>
          </div>
          <div className="justify-center">
            <div
              onClick={payHandler}
              className="bg-secondary w-full h-10 text-white max-w-[10rem] text-center lg:text-[14px] text-[16px] uppercase py-2 rounded-sm mt-5 hover:bg-gray-300 hover:text-black cursor-pointer"
            >
              Pay Now
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(BookingSummary);

export const PassengerDetailItem = ({ iconName, text, label }) => {
  return (
    <div className="flex items-center space-x-2">
      <FontAwesomeIcon icon={iconName} className="w-10 text-slate-600" />
      <span className="text-[15px] w-40 text-black">{label}:</span>
      <div className="text-[15px] text-gray-600 font-normal">{text}</div>
    </div>
  );
};
